export default __webpack_public_path__ + "static/media/smoke.e59b9003.gif";